import { Form, Input, Select } from 'antd';
import PropTypes from 'prop-types';

const equipmentPropType = PropTypes.shape({
    id: PropTypes.number,
    companyId: PropTypes.number,
    count: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
});
const equipmenToTrailPropType = PropTypes.shape({
    id: PropTypes.number,
    price: PropTypes.number,
    equipment: equipmentPropType,
});
const propTypes = {
    equipmentToTrail: equipmenToTrailPropType,
    equipments: PropTypes.arrayOf(equipmentPropType).isRequired,
    trail: PropTypes.shape({
        equipmentToTrail: PropTypes.arrayOf(equipmenToTrailPropType),
    }).isRequired,
};

function TrailEquipmentForm({ form, equipmentToTrail, equipments, trail }) {
    const editMode = !!equipmentToTrail;

    let options = equipments.map((e) => ({
        label: e.title,
        value: e.id,
    }));

    if (!editMode) {
        const usedEquipmentIds = trail.equipmentToTrail.map(
            (t) => t.equipment.id,
        );
        options = options.filter((x) => !usedEquipmentIds.includes(x.value));
    }

    return (
        <div style={{ marginTop: 20 }}>
            <Form
                form={form}
                // layout="vertical"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                autoComplete="off"
            >
                <Form.Item
                    label="Sprzęt"
                    name={['equipment', 'id']}
                    rules={[
                        {
                            required: true,
                            message: 'Pole wymagane',
                        },
                    ]}
                >
                    <Select disabled={editMode} options={options} />
                </Form.Item>
                <Form.Item
                    label="Cena (za sztukę)"
                    name="price"
                    rules={[
                        {
                            required: true,
                            message: 'Pole wymagane',
                        },
                    ]}
                >
                    <Input type="number" />
                </Form.Item>
            </Form>
        </div>
    );
}

TrailEquipmentForm.propTypes = propTypes;

export default TrailEquipmentForm;
